import {SchemeLink} from '../../../applink/SchemeLink';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ButtonTab} from '../../atoms/ButtonTab/ButtonTab';
import {ScrollableThemeKeywordTabProps} from './ScrollableThemeKeywordTabProps.interface';

export function ScrollableThemeKeywordTab({
  className,
  itemList,
  onClickThemeTab,
  ...props
}: ScrollableThemeKeywordTabProps) {
  return (
    <div
      className={twMerge(
        'flex h-44pxr w-full items-center justify-between overflow-x-scroll bg-theme-bg-base scrollbar-hide',
        className
      )}
      {...props}
    >
      <div className="flex shrink-0 items-center space-x-8pxr">
        {itemList.map((item, index) => (
          <SchemeLink
            scheme={item.scheme || undefined}
            key={item.uid}
            linkClassName="shrink-0"
          >
            <ButtonTab
              className="font-small1 select-none rounded-32pxr border-none bg-theme-solid-10 py-7pxr px-14pxr"
              onClick={onClickThemeTab}
              {...putTiaraObjectProps({
                click: {ordnum: String(index + 1), copy: item.title},
              })}
            >
              {item.title}
            </ButtonTab>
          </SchemeLink>
        ))}
      </div>
    </div>
  );
}
